import { Navbar } from "@/components/site/Navbar";
import { CinematicExperience } from "@/components/site/CinematicExperience";

// Hard stop: Portal -> Hero is the entire homepage. No scrollable content
// beneath the hero loop — Music/Videos/Tour/Photos/Community/stats all live
// on their own dedicated pages (see App.js routes), not here. No code
// fireflies here — the Portal loop has its own (added in Motionleap).
export default function Home() {
  return (
    <div data-testid="home-page" className="relative bg-[var(--sm-black)]">
      <Navbar />
      <CinematicExperience />
    </div>
  );
}
